import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component that allows the user to select one of many options. A replacement
 * for the normal HTML `select` element.
 * @remarks If using v-wmodel, always add the modifier .lazy
 */
var DropdownComponent = /** @class */ (function (_super) {
    __extends(DropdownComponent, _super);
    function DropdownComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isFocused = false;
        return _this;
    }
    DropdownComponent.prototype.changed = function (target) {
        if (target.value === '') {
            return target.value;
        }
        target.blur();
        return this.options[+target.value].value;
    };
    DropdownComponent.prototype.setFocused = function (isFocused) {
        this.isFocused = isFocused;
    };
    Object.defineProperty(DropdownComponent.prototype, "hasValue", {
        get: function () {
            var _this = this;
            return (this.value &&
                (this.options || []).some(function (option) {
                    return option.value === _this.value;
                }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "placeholderLabel", {
        get: function () {
            return this.hasEmptyPlaceholder ? '' : this.placeholder;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "hasEmptyPlaceholder", {
        get: function () {
            return ['true', '', 'placeholder', true].includes(this.placeholder);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DropdownComponent.prototype, "currentOption", {
        get: function () {
            var _this = this;
            var _a;
            var selected = (_a = this.options) === null || _a === void 0 ? void 0 : _a.find(function (option) {
                return option.value === _this.value;
            });
            if (!selected) {
                return this.placeholderLabel;
            }
            return selected.name;
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "ellipsis", void 0);
    __decorate([
        Prop({
            validator: function (options) {
                if (!options || !Array.isArray(options)) {
                    return true;
                }
                var isValid = options.every(function (option) {
                    if (!option) {
                        return false;
                    }
                    var name = option.name, value = option.value;
                    var valid = name !== undefined && value !== undefined;
                    // In development mode, warn about potentially problematic options
                    if (process.env.NODE_ENV !== 'production' && !valid) {
                        console.warn('[UiDropdown] Invalid option detected:', option, 'Options must have both name and value properties defined.');
                    }
                    return valid;
                });
                return isValid;
            },
        }),
        __metadata("design:type", Array)
    ], DropdownComponent.prototype, "options", void 0);
    __decorate([
        Prop(),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "value", void 0);
    __decorate([
        Prop({
            validator: function (value) {
                return typeof value === 'string' || typeof value === 'boolean';
            },
            default: false,
        }),
        __metadata("design:type", Object)
    ], DropdownComponent.prototype, "placeholder", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "disabled", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "light", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "link", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "small", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], DropdownComponent.prototype, "allowEmpty", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], DropdownComponent.prototype, "iconPrefix", void 0);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [HTMLSelectElement]),
        __metadata("design:returntype", void 0)
    ], DropdownComponent.prototype, "changed", null);
    DropdownComponent = __decorate([
        Component({
            name: 'ui-dropdown',
        })
    ], DropdownComponent);
    return DropdownComponent;
}(Mixins(MagicConfigMixin)));

export default DropdownComponent;
